import defaultAttributes from '../defaultAttributes';

const Redo = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M21 7v6h-6' }],
    ['path', { d: 'M3 17a9 9 0 019-9 9 9 0 016 2.3l3 2.7' }],
  ],
];

export default Redo;
